module.exports = __webpack_public_path__ + "img/placeholder_relationshipmap@2x.0df1ac7d.png";